import { render } from "./HomeView.vue?vue&type=template&id=0644fcc2&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=0644fcc2&lang=scss&scoped=true"

import exportComponent from "/Users/wuyi/git/9cloud/vue-office-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0644fcc2"]])

export default __exports__